
import {
    getPhaseStatus,
    getItem,
    
} from "./debriefingUtils";

import {
    hasSubPhases,
} from "./actionInsertion"


//to display the log using the phase structures accumulated
// i.e. puts the phases data together in the order in which
// should be displayed in debriefing log
export const organizeLogDisplay = (phaseNames, phases, requiredPhaseNames, problemStates, cautionStates, checklistHierarchy, subPhases, phaseFB,itemByID,itemByLabel) => {
    let displayObjects = [];
    let entryIndex = 1;
    let headerIndex = 1;
    let problemHeaderColor = "green"
    let subPhaseColor = "green"
    let subPhaseStatuses = []
    let phaseStatuses = []
    let newPhaseObjects = []
    let headerObj = {
        "id": "assessmentHeader",
        "status": "",
        "phaseOrderStatus": "good",
        "feedback": "",
        "type": "header",
        "numericalID": 1,
        "displayColor": "",
        "why": "",
        "label": "",
        "labelID": "",
        "protocol": ""
    };
    let subHeaderObj = {
        "id": "assessmentSubHeader",
        "status": "",
        "phaseOrderStatus": "good",
        "feedback": "",
        "type": "header",
        "numericalID": 1,
        "displayColor": "",
        "why": "",
        "label": "",
        "labelID": "",
        "phaseID": "",
        "protocol": ""
    };

    let priorHLPhaseItem = ""
    let endEntry = false
    for (let phaseIndex = 0; phaseIndex < phaseNames.length; phaseIndex++) {
        let iPhaseObjects = phases[phaseIndex];
        let phaseName = phaseNames[phaseIndex];
        let process = true

        if (requiredPhaseNames.includes(phaseName) && hasSubPhases(phaseName, checklistHierarchy)) {
            process = false}

        if (iPhaseObjects.length > 0 && process) {
                //for this set of objects, find the worst scoring item
            let phaseObjects = phases[phaseIndex];
            subPhaseColor = "green"
            for (let phaseObject of phaseObjects) {
                if (phaseObject.type !== "intervention"){
                    subPhaseStatuses.push(phaseObject.status)}
                //else {hierProblemResults.push(phaseObject)}
                if (problemStates.includes(phaseObject.status)) {
                    subPhaseColor = "red";
                }
                // Red has a higher priority than yellow so will allow to override it
                if (cautionStates.includes(phaseObject.status) && subPhaseColor !== "red") {
                    subPhaseColor = "yellow";
                }
                phaseObject.numericalID = entryIndex++;
                //entryIndex++;
            };

            let subheader = Object.assign({}, subHeaderObj)
            let localPhaseItem
            let localPhaseName
            if (phaseNames[phaseIndex] === "Unknown"){
                localPhaseName = phaseObjects[0].expertPhase
                if (localPhaseName === ""){
                    localPhaseName = phaseNames[1]
                }
            }
            else {
                localPhaseName = phaseNames[phaseIndex]}
            localPhaseItem = getItem(localPhaseName,itemByID,itemByLabel) 
            if (!!localPhaseItem){
                subheader.label = localPhaseItem.label
                subheader.labelID = localPhaseItem.id}
            subheader.status = getPhaseStatus(subPhaseStatuses)
            subheader.displayColor = subPhaseColor
            if (!!phaseFB[subheader.label]) {
                subheader.phaseOrderStatus = "misOrdered"
                subheader.phFeedback = phaseFB[subheader.label].feedback
                subheader.lateRelativeTo = phaseFB[subheader.label].arg2
            }
               
            let highLevelPhase = subPhases[localPhaseName]
            let highLevelPhaseItem = getItem(highLevelPhase, itemByID, itemByLabel)
            
            

            //Note that the inserted headers will have their own numerical id and
            //am dividing by 1000 for headers so their numerical id will be unique
            //to headers.  Am assuming we would never have more than 1000 events
            //observed.  Will use the numerical ids for testing before and after
            //constraints.

            if (priorHLPhaseItem === "") {
                priorHLPhaseItem = highLevelPhaseItem
                problemHeaderColor = determineHLcolor(subPhaseColor, problemHeaderColor)
            }

            if (phaseIndex === phaseNames.length - 1) {
                //this closes out the prior phase and the new subphase
                let header = Object.assign({}, headerObj)
                if (!!priorHLPhaseItem && !!priorHLPhaseItem.label && highLevelPhase !== priorHLPhaseItem.label){    //ending with start of a new phase
                    header.label = priorHLPhaseItem.label
                    header.labelID = priorHLPhaseItem.id
                    header.status = getPhaseStatus(phaseStatuses)
                    header.displayColor = problemHeaderColor;
                    header.numericalID = headerIndex++ / 1000
                    if (!!phaseFB[header.label]){
                        header.phaseOrderStatus = "misOrdered"
                        header.phFeedback = phaseFB[header.label].feedback
                        header.lateRelativeTo = phaseFB[header.label].arg2
                    }
                    displayObjects.push(header)
                    displayObjects.push(...newPhaseObjects)
                    newPhaseObjects = []}

                header = Object.assign({}, subheader)
                header.label = highLevelPhaseItem.label
                header.labelID = highLevelPhaseItem.id
                header.id = "assessmentHeader"
                header.numericalID = headerIndex++ / 1000
                displayObjects.push(header)

                if (highLevelPhase === subheader.label) {
                    displayObjects.push(...newPhaseObjects)
                    displayObjects.push(...phaseObjects)}
                else {
                    subheader.numericalID = headerIndex++ / 1000
                    displayObjects.push(...newPhaseObjects)
                    displayObjects.push(subheader)
                    displayObjects.push(...phaseObjects)}
                endEntry = true;
            }

            //save the accumulated high-level phase if the phase changes
            if (!endEntry) {
                if (!!priorHLPhaseItem && !!priorHLPhaseItem.label && highLevelPhase !== priorHLPhaseItem.label) {
                    let header = Object.assign({}, headerObj)
                    header.label = priorHLPhaseItem.label
                    header.labelID = priorHLPhaseItem.id
                    header.status = getPhaseStatus(phaseStatuses)
                    if (!!phaseFB[header.label]){
                        header.phaseOrderStatus = "misOrdered"
                        header.phFeedback = phaseFB[header.label].feedback
                        header.lateRelativeTo = phaseFB[header.label].arg2
                    }
                    phaseStatuses = []
                    header.displayColor = problemHeaderColor;
                    header.numericalID = headerIndex++ / 1000
                    displayObjects.push(header)
                    displayObjects.push(...newPhaseObjects)
                    //reinitialize for the new phase
                    phaseStatuses.push(...subPhaseStatuses)
                    subPhaseStatuses = []
                    if (highLevelPhase === subheader.label) {
                        newPhaseObjects = [...phaseObjects]
                    }
                    else {
                        subheader.numericalID = headerIndex++ / 1000
                        newPhaseObjects = [subheader]
                        newPhaseObjects.push(...phaseObjects)
                    }
                    priorHLPhaseItem = highLevelPhaseItem
                    problemHeaderColor = determineHLcolor(subPhaseColor, "green")
                }
                else {
                    problemHeaderColor = determineHLcolor(subPhaseColor, problemHeaderColor)
                    phaseStatuses.push(...subPhaseStatuses)
                    subPhaseStatuses = []
                    if (highLevelPhase === subheader.label) {
                        newPhaseObjects.push(...phaseObjects)
                    }
                    else {
                        subheader.numericalID = headerIndex++ / 1000
                        newPhaseObjects.push(subheader)
                        newPhaseObjects.push(...phaseObjects)
                    }
                }
            }

        }
    }
    return displayObjects;
}

const determineHLcolor = (lowerColor, higherColor) => {
    let newColor = higherColor
    if (lowerColor === "red") {
        newColor = "red"
    }
    if (lowerColor === "yellow" && newColor !== "red") {
        newColor = "yellow"
    }
    return newColor
}